// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".watchers_utils-module__lawyerPicture--vWsLS{height:32px;width:32px;border-radius:100%;background-size:cover}\n", ""]);
// Exports
exports.locals = {
	"lawyerPicture": "watchers_utils-module__lawyerPicture--vWsLS"
};
module.exports = exports;
